export default {
    conditionImport: 'Import File Conditions',
    firstImportCondition: 'File must be in Excel format including Employee information : Citizen ID / Passport ID, Employee name, Employee ID, Gender, Date of birth, Department, Branch, Email address, Phone number.',
    secondImportCondition: 'After uploading an Excel file, then upload the facial image of employee on the list.',
    thirdImportCondition: 'Please verify that the information in Excel file is correct before upload.',
    uploadFile: 'Upload your file',
    shouldBeExcel: 'File should be Excel',
    dragDrop: 'Drag & Drop your file here or',
    browse: 'Browse',
    uploadOneFile: 'Please upload one file at a time',
    wrongFileFormat: 'The file format is not supported',
    uploadedFile: 'Uploaded files',
    importResult: 'Importing Employee List'
}
